import { z } from 'zod';

import { httpGetAdapter } from '@/lib/adapters/httpGetAdapter';

const dashboardClassSchema = z.object({
  id: z.number(),
  nome: z.string(),
  nomAnoEscolar: z.string().optional(),
});

export type DashboardClass = z.infer<typeof dashboardClassSchema>;
export type DashboardClassesResponse = DashboardClass[];

const dashboardClassesResponseSchema = z.array(dashboardClassSchema);

export type GetDashboardClassesParams = {
  redeId?: string;
  escolaId?: number;
  anoLetivo?: number;
  anoEscolar?: number;
};

export const getDashboardClasses = httpGetAdapter<DashboardClassesResponse, GetDashboardClassesParams>({
  url: '/v3/dashboard/resultado/turmas',
  schema: dashboardClassesResponseSchema,
  mapParams: (params) => ({
    ...(params?.redeId ? { redeId: params.redeId } : {}),
    ...(params?.escolaId ? { escolaId: params.escolaId } : {}),
    ...(params?.anoLetivo ? { anoLetivo: params.anoLetivo } : {}),
    ...(params?.anoEscolar ? { anoEscolar: params.anoEscolar } : {}),
  }),
});
